import { categoryIcons, skillIcons } from "@/data/icons"
import { portfolioData } from "@/data/portfolioData"
import { Badge } from "@/components/ui-lab/badge"
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui-lab/card"
import { FaCode } from "react-icons/fa"
import { TagIcon } from "../custom/Tag"

export const MySkill = () => {
  const { skills } = portfolioData
  // Organize skills for display
  const skillCategories = {
    Frontend: skills.frontend,
    Backend: skills.backend,
    Databases: skills.databases,
    "Cloud & DevOps": [...skills.cloud_infrastructure, ...skills.devops],
    Tools: skills.tools,
    Other: skills.other,
  }

  return (
    <>
      <h2 className="text-3xl font-semibold mb-6 flex items-center gap-2">
        <FaCode /> Technical Skills
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {Object.entries(skillCategories).map(([category, items]) => (
          <Card
            key={category}
            className="h-full shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-1 hover:border-teal-500 border-2 border-transparent"
          >
            <CardHeader className="border-b px-6 py-4">
              <CardTitle className="text-base flex items-center gap-2">
                {categoryIcons[category]}
                {category}
              </CardTitle>
            </CardHeader>
            <CardContent className="p-6">
              <div className="flex flex-wrap gap-2">
                {items.map((skill) => (
                  <Badge
                    key={skill}
                    variant="tech"
                    className="text-sm font-normal py-1 px-3 cursor-default transition-all duration-300 hover:scale-110 hover:shadow-md"
                  >
                    <TagIcon text={skill} icon={skillIcons[skill]} />
                  </Badge>
                ))}
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </>
  )
}
